import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export const Logout = () => {
    const auth = useContext(AuthContext);
    let navigate = useNavigate();

    if (auth?.authService.isAuthenticated()){
         auth?.authService.logout(true);
    }
    else {
        navigate("/");
    }
    return <></>;  
}